if (!customElements.get('volta-product-download-slot')) {
  customElements.define('volta-product-download-slot', class extends HTMLElement {
    connectedCallback() {
      const placeDownloads = () => {
        const downloads = this.closest('main')?.querySelector('[data-vm-product-downloads]');
        if (downloads && !this.contains(downloads)) this.append(downloads);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', placeDownloads, {once: true});
      } else {
        placeDownloads();
      }
    }
  });
}
